import { deepEqual } from '@bigmi/core';
let previousConnectors = [];
export function getConnectors(config) {
    const connectors = config.connectors;
    if (deepEqual(previousConnectors, connectors)) {
        return previousConnectors;
    }
    previousConnectors = connectors;
    return connectors;
}
//# sourceMappingURL=getConnectors.js.map